import React, { PropsWithChildren, ReactElement, ReactNode } from 'react';
import FormItemBox from '@app/components/inputs/FormItemBox';
import { GetFieldDecoratorOptions } from 'antd/lib/form/Form';
import styled from '@emotion/styled';

interface Props {
  fieldName: string;
  fieldDecoratorOptions: GetFieldDecoratorOptions | null;
  children: ReactElement;
  additionalContent: ReactNode;
  dataTestId?: string;
  className?: string;
  hidden?: boolean;
}

const FormItemBoxWithText = (props: PropsWithChildren<Props>): ReactElement => {
  const { fieldName, fieldDecoratorOptions, children, additionalContent, dataTestId, className, hidden = false } = props;

  return (
    <Container>
      <FormItemBox
        fieldName={fieldName}
        fieldDecoratorOptions={fieldDecoratorOptions}
        expandBelow={!!additionalContent}
        hidden={hidden}
      >
        {children}
      </FormItemBox>
      {!hidden && additionalContent && (
        <AdditionalContent data-testid={dataTestId} className={className}>
          {additionalContent}
        </AdditionalContent>
      )}
    </Container>
  );
};

export default FormItemBoxWithText;

const Container = styled.div`
  width: 100%;
`;

const AdditionalContent = styled.div`
  margin-top: 4px;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--transparent-black-900);
  padding: 4px 0;
`;
